"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getSetFromIdsList;
function getSetFromIdsList(list) {
    var map = {};
    list && list.forEach(function (x) {
        map[x] = true;
    });
    return map;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvZ2V0U2V0RnJvbUlkc0xpc3QuanN4Il0sIm5hbWVzIjpbImdldFNldEZyb21JZHNMaXN0IiwibGlzdCIsIm1hcCIsImZvckVhY2giLCJ4Il0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLGlCO0FBQVQsU0FBU0EsaUJBQVQsQ0FBMkJDLElBQTNCLEVBQWlDO0FBQzVDLFFBQU1DLE1BQU0sRUFBWjtBQUNBRCxZQUFRQSxLQUFLRSxPQUFMLENBQWEsYUFBSztBQUFDRCxZQUFJRSxDQUFKLElBQVMsSUFBVDtBQUFjLEtBQWpDLENBQVI7QUFDQSxXQUFPRixHQUFQO0FBQ0giLCJmaWxlIjoiZ2V0U2V0RnJvbUlkc0xpc3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRTZXRGcm9tSWRzTGlzdChsaXN0KSB7XG4gICAgY29uc3QgbWFwID0ge307XG4gICAgbGlzdCAmJiBsaXN0LmZvckVhY2goeCA9PiB7bWFwW3hdID0gdHJ1ZX0pO1xuICAgIHJldHVybiBtYXBcbn1cbiJdfQ==